module.exports = __webpack_public_path__ + "static/media/Kristalina_tablet.67ffbfd2.jpg";